import React, { CSSProperties } from "react"

import * as styles from "./index.module.scss"

type Variant = "top" | "bottom" | "left" | "right"

type Props = {
  size: string
  zIndex?: number
  variant: Variant
}

const SCROLLBAR_SIZE = "12px"

const getVariantStyles = (variant: Variant, size: string): CSSProperties => {
  const isHorizontal = ["left", "right"].includes(variant)
  return {
    [variant]: 0,
    background: `linear-gradient(to ${variant}, rgba(255, 255, 255, 0) 0%, #fff 100%)`,
    [isHorizontal ? "width" : "height"]: size,
    ...(isHorizontal
      ? {
          top: 0,
          bottom: SCROLLBAR_SIZE,
        }
      : {
          left: 0,
          right: SCROLLBAR_SIZE,
        }),
  }
}

function ScrollContinuationGradient({ size, variant, zIndex }: Props) {
  return (
    <div
      style={{ zIndex, ...getVariantStyles(variant, size) }}
      className={styles.gradient}
    />
  )
}

export default ScrollContinuationGradient
